module.exports = __webpack_public_path__ + "static/media/005.9c7c763f.jpg";